import moneyFormat from '../functions/moneyFormat'; 
import decimalToPercent from '../functions/decimalToPercent'; 
import { TableCell } from '@mui/material';

const AggregateTotalsFooter = ({tableHeader, footerObj, rebateInputTypeId,stickyEnabled, boxColor}) => {

    // const style = {backgroundColor: "#339378", color: "#ffffff !important", borderRight:"1px white solid",borderLeft:"1px white solid"}
    // const styleWithoutBorder = {backgroundColor: "#339378", color: "#ffffff !important"}

    const style = {backgroundColor: "#E6EDF1", color: "#000000 !important", borderRight:"1px white solid",borderLeft:"1px white solid"}
    const styleWithoutBorder = {backgroundColor: "#E6EDF1", color: "#000000 !important"}

    // old color: #E6EDF1

    const determineBorder = (val) => {
        if(typeof val === 'undefined' || typeof val === 'string'){
            return styleWithoutBorder
        }
        return style
    }

    // optional box around the totals row (top/bottom on every cell, left on first cell, right on last cell)
    const getBoxStyle = (index) => {
        if (!boxColor) {
            return {};
        }
        const border = '2px solid ' + boxColor;
        return {
            borderTop: border, 
            borderBottom: border, 
            ...(index === 0 && { borderLeft: border }), 
            ...(index === tableHeader.length - 1 && { borderRight: border }), 
        };
    }

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-footer": ""
    }

    return(
        <>
            {tableHeader.map( (el, index) => 
                el['columnname'] == 'cyclenetspend' || el['columnname'] == 'cyclenetinterchange' || el['columnname'] == 'cycleincentiveamount' ? 
                    <TableCell className={getRowClassName(el['columnorder'])} align='right' sx={{...determineBorder(footerObj[el['columnname']]), ...getBoxStyle(index)}}>{moneyFormat(footerObj[el['columnname']])}</TableCell>
                : el['columnname'] == 'incentiverate' && rebateInputTypeId == 1 && footerObj[el['columnname']] != null ? 
                    // apply transformation depending on rebate input type id
                    <TableCell className={getRowClassName(el['columnorder'])} align='right' sx={{...determineBorder(footerObj[el['columnname']]), ...getBoxStyle(index)}}>{decimalToPercent(footerObj[el['columnname']])}</TableCell>
                : <TableCell className={getRowClassName(el['columnorder'])} sx={{...determineBorder(footerObj[el['columnname']]), ...getBoxStyle(index)}}>{footerObj[el['columnname']]}</TableCell>
            )} 
        </>
    ); 
}

export default AggregateTotalsFooter; 

